
import angular from "angular";

import Assert from "tbAssert";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import TrackingTargetsViewModuleConstants from "./Constants";
import TrackingTargetsViewController from "./TrackingTargetsViewController";

function TrackingTargetsViewConfiguration($stateProvider) {
    Assert.StrictAssert($stateProvider != null, "Assertion Failure: Missing UI Router State Provider Dependency");

    $stateProvider.state(TrackingTargetsViewModuleConstants.rootStateName, {
        url: "/tracking-target/{targetId}",
        template: TrackingTargetsViewController.template,
        controller: TrackingTargetsViewController,
        controllerAs: TrackingTargetsViewController.controllerAs,
        data: {
            requiresLogin: true
        },
        params: {
            targetId: { squash: true, value: null, dynamic: true }
        }
    });
}

TrackingTargetsViewConfiguration.$inject = [
    "$stateProvider"
];

TrackingTargetsViewConfiguration.dependencies = [
    "ui.router"
];

const trackingTargetsViewModuleDependencies = DependencyListBuilder([
    TrackingTargetsViewConfiguration.dependencies,
    TrackingTargetsViewController.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.tracking-targets-view",
        trackingTargetsViewModuleDependencies
    )
    .config(TrackingTargetsViewConfiguration)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-targets-view/TrackingTargetsView.js
// module id = eCYq
// module chunks = 1